/* src/app/home/trailer-request/request-info/request-info.component.scss */
@media (min-width: 1880px) {
  .xl-d-none {
    display: none !important;
  }
}
.move-up {
  margin-top: -20px;
}
.col,
.col-lg-5 {
  padding: 0px !important;
  line-height: 17px;
}
.pending-removal {
  color: #6E6E6E;
  font-weight: 400;
  white-space: nowrap;
}
.request-info {
  display: grid;
  grid-template-columns: auto 1fr;
  white-space: nowrap;
  column-gap: 16px;
}
.request-info > div {
  display: contents;
}
/*# sourceMappingURL=request-info.component.css.map */
